import React, { useState, useEffect } from "react";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handle = (value) => {
    localStorage.setItem("cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-[#1b1d2b] border-t border-white/10 fade-in-up">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="font-display font-semibold text-white text-sm mb-1">Cookie Consent</p>
          <p className="text-xs text-white/60 leading-relaxed max-w-3xl">
            We serve cookies. We use tools, such as cookies, to enable essential services and
            functionality on our site and to collect data on how visitors interact with our site,
            products and services. By clicking Accept, you agree to our use of these tools for
            advertising, analytics and support.
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={() => handle("declined")}
            className="px-5 py-2 rounded-md text-sm font-semibold text-white bg-white/10 hover:bg-white/15 transition-colors"
          >
            Decline
          </button>
          <button
            onClick={() => handle("accepted")}
            className="px-5 py-2 rounded-md text-sm font-semibold text-white bg-[#25D366] hover:bg-[#1fb757] transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
